import uuidv4 from 'uuid-browser/v4';
import snackbar from 'components/snackbar';
import setLoading from 'components/loading';
import { saveApplication, debounce } from '../../../utilities';
import { DEBOUNCE_TIME } from '../../../constants';
import { changeUpload } from 'utils';
import { defaultOptionalDocs } from '../../../types';
import validate from '../../../validations';

export default {
  refreshOn: ({ }) => [],
  init: (fullState, stateManager, internalStateSetter) => {
    debounce(() => saveApplication(stateManager), DEBOUNCE_TIME);
  },
  'Uploads.Wrapper.MainWrapper.PayStubWrapper.PayStubUpload.PayStubWebCamBtn': ({ toggleWebCam }, stateManager) => {
    stateManager.setToggleWebCam({ label: toggleWebCam });
  },
  'Uploads.Wrapper.MainWrapper.OptionalDocWrapper.OptionalUpload.OptionalWebCamBtn': ({ toggleWebCam }, stateManager) => {
    stateManager.setToggleWebCam(toggleWebCam);
  },
  'Uploads.Wrapper.MainWrapper.PayStubWrapper.PayStubUpload.UploadButton': async ({ value, uploadedDoc }, stateManager) => {
    const { isEditMode } = stateManager.store.getState();
    setLoading(true)
    try {
      const { uuid, url } = await changeUpload(value, stateManager.setUploadedDoc, uploadedDoc, 'payStubUrl');
      setLoading(false)
      const updatedDoc = { ...uploadedDoc, payStubID: uuid, payStubUrl: url, payStubIDError: '', hasError: false };
      stateManager.setUploadedDoc(updatedDoc);

      !isEditMode && validate(250);
    } catch {
      setLoading(false)
    }
  },
  'Uploads.Wrapper.MainWrapper.PayStubWrapper.PayStubUpload.UploadedImage': ({ uploadedDoc }, stateManager) => {
    
    const updatedDoc = { ...uploadedDoc, payStubID: '', payStubUrl: '' };
    stateManager.setUploadedDoc(updatedDoc);

    const { isEditMode } = stateManager.store.getState();
    !isEditMode && validate(250);
  },
  'Uploads.Wrapper.MainWrapper.PhotoDocsWrapper.PhotoDocs': async ({ toggleWebCam, docs }, stateManager) => {
    !!toggleWebCam?.label && stateManager.setToggleWebCam(toggleWebCam);
    stateManager.setPhotoIDs(docs);
  },
  'Uploads.Wrapper.MainWrapper.OptionalDocWrapper.OptionalDocs': async ({ toggleWebCam, docs }, stateManager) => {
    !!toggleWebCam?.label && stateManager.setToggleWebCam(toggleWebCam);
    stateManager.setOptionalDocs(docs);
  },
  'Uploads.Wrapper.MainWrapper.ButtonWrapper.AddOptionalDoc': ({ optionalDocs }, stateManager) => {
    const fieldsHaveDoc = optionalDocs.every((doc) => !!doc.docUrl);
    if (!fieldsHaveDoc) {
      snackbar({
        message: 'First upload documents in available fields',
        args: { type: 'info' }
      });

      return;
    }

    const newDocument = { ...defaultOptionalDocs };
    newDocument.id = uuidv4();

    stateManager.setOptionalDocs([...optionalDocs, newDocument]);
  }
};
